import { login, logout, getInfo } from "@/api/login";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { cacheClear } from "@/utils/cache";

const user = {
  state: {
    token: getToken(),
    name: "",
    type: "",
    avatar: "",
    roles: [],
    gender: ""
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_TYPE: (state, type) => {
      state.type = type;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_STATUS: (state, status) => {
      state.status = status;
    },
    SET_GENDER: (state, gender) => {
      state.gender = gender;
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim();
      return new Promise((resolve, reject) => {
        login(username, userInfo.password)
          .then(response => {
            const data = response.data;
            const tokenStr = data.tokenHead + data.token;
            setToken(tokenStr);
            commit("SET_TOKEN", tokenStr);
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo()
          .then(response => {
            const data = response.data;
            console.log(data);

            commit("SET_ROLES", ["admin"]);
            commit("SET_NAME", data.displayName);
            commit("SET_TYPE", data.userType);
            commit(
              "SET_AVATAR",
              data.gender == "Female"
                ? "../../../static/imgs/Female.png"
                : "../../../static/imgs/Male.png"
            );
            commit("SET_STATUS", data.status);
            commit("SET_GENDER", data.gender);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            commit("SET_TOKEN", "");
            commit("SET_ROLES", []);
            removeToken();
            cacheClear();
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit("SET_TOKEN", "");
        removeToken();
        cacheClear();
        resolve();
      });
    }
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js